<div class="call-destination-container">
  <div class="call-destination-card">
    <div class="card-header">
      <h3>Origen y Destino</h3>
    </div>

    <div class="card-content">
      <!-- Sección de Origen -->
      <div class="address-section">
        <div class="section-with-options" [class.has-user-addresses]="hasUserAddresses">
          <label class="field-label">Últimas direcciones registradas</label>

          <!-- Radio buttons para direcciones de origen -->
          <div class="address-options" *ngIf="displayJourneys.length > 0">
            <ion-radio-group [(ngModel)]="selectedOriginIndex" (ionChange)="onOriginRadioChange($event)">
              <div class="address-option" *ngFor="let journey of displayJourneys; let i = index">
                <ion-item lines="none" class="radio-item" (click)="onOriginAddressSelected(i)">
                  <ion-radio mode="md" [value]="i" slot="start"
                    [attr.aria-label]="journey.fromAddress.title + (journey.fromAddress.description ? ' - ' + journey.fromAddress.description : '')"></ion-radio>
                  <div class="address-label">
                    <div class="address-text">
                      <span class="address-title">{{ journey.fromAddress.title }}</span>
                      <span class="address-description" *ngIf="journey.fromAddress.description">
                        - {{ journey.fromAddress.description }}
                      </span>
                    </div>
                  </div>
                </ion-item>
              </div>
            </ion-radio-group>
          </div>
        </div>

        <div class="input-field">
          <div class="field-label-container">
            <label class="field-label required">Origen</label>
            <ion-checkbox [(ngModel)]="useInternalSearchOrigin" (ionChange)="onInternalSearchOriginChange($event)">
              <ion-label>{{ 'sip.internal_search' | translate }}</ion-label>
            </ion-checkbox>
          </div>

          <!-- Campo de búsqueda interna -->
          <div *ngIf="useInternalSearchOrigin" class="internal-search-container">
            <input type="text" class="internal-search-input" [(ngModel)]="internalSearchTextOrigin"
              (input)="onInternalSearchInput('origin', $event)"
              (focus)="showInternalOrigin = internalDirectionsOrigin.length > 0" (blur)="onInternalSearchBlur('origin')"
              [placeholder]="'general.search' | translate">

            <!-- Dropdown de resultados -->
            <div class="internal-directions-dropdown" *ngIf="showInternalOrigin && internalDirectionsOrigin.length > 0">
              <div class="dropdown-header">Direcciones internas</div>
              <div class="dropdown-list">
                <div class="dropdown-item" *ngFor="let direction of internalDirectionsOrigin"
                  (mousedown)="selectInternalOrigin(direction)">
                  <div class="address-title">{{ direction.title }}</div>
                  <div class="address-description" *ngIf="direction.description">{{ direction.description }}</div>
                  <div class="address-description">{{ direction.fromAddress }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Campo de Google Autocomplete -->
          <div *ngIf="!useInternalSearchOrigin" #originContainer class="google-autocomplete-container"></div>

          <!-- Campo de solo lectura para mostrar la dirección seleccionada -->
          <div class="selected-address-display" *ngIf="selectedOriginText">
            <ion-icon name="location" class="address-icon"></ion-icon>
            <span class="address-text">{{ selectedOriginText }}</span>
          </div>
        </div>
      </div>

      <!-- Sección de Destino -->
      <div class="address-section">
        <div class="input-field">
          <div class="field-label-container">
            <label class="field-label">Destino</label>
            <ion-checkbox [(ngModel)]="useInternalSearchDestination"
              (ionChange)="onInternalSearchDestinationChange($event)">
              <ion-label>{{ 'sip.internal_search' | translate }}</ion-label>
            </ion-checkbox>
          </div>

          <!-- Campo de búsqueda interna -->
          <div *ngIf="useInternalSearchDestination" class="internal-search-container">
            <input type="text" class="internal-search-input" [(ngModel)]="internalSearchTextDestination"
              (input)="onInternalSearchInput('destination', $event)"
              (focus)="showInternalDestination = internalDirectionsDestination.length > 0"
              (blur)="onInternalSearchBlur('destination')" [placeholder]="'general.search' | translate">

            <!-- Dropdown de resultados -->
            <div class="internal-directions-dropdown"
              *ngIf="showInternalDestination && internalDirectionsDestination.length > 0">
              <div class="dropdown-header">Direcciones internas</div>
              <div class="dropdown-list">
                <div class="dropdown-item" *ngFor="let direction of internalDirectionsDestination"
                  (mousedown)="selectInternalDestination(direction)">
                  <div class="address-title">{{ direction.title }}</div>
                  <div class="address-description" *ngIf="direction.description">{{ direction.description }}</div>
                  <div class="address-description">{{ direction.fromAddress }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Campo de Google Autocomplete -->
          <div *ngIf="!useInternalSearchDestination" #destinationContainer class="google-autocomplete-container"></div>

          <!-- Campo de solo lectura para mostrar la dirección seleccionada -->
          <div class="selected-address-display" *ngIf="selectedDestinationText">
            <ion-icon name="location" class="address-icon"></ion-icon>
            <span class="address-text">{{ selectedDestinationText }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>